export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_EN.78a73f1e.png";